export default "__VITE_ASSET__C6ho3o3w__"